import { Paper, Typography } from '@mui/material';
import { ShieldAlert } from 'lucide-react';

export const ForbiddenPage = () => (
  <Paper sx={{ p: 4, textAlign: 'center' }} variant="outlined">
    <ShieldAlert size={32} />
    <Typography sx={{ fontSize: 16, fontWeight: 600, mt: 1.5 }}>You don&apos;t have access to this utility</Typography>
    <Typography color="text.secondary" sx={{ mt: 0.5 }} variant="body2">
      Ask an admin to add you to the Cognito group for this Utility, then logout & back in.
    </Typography>
  </Paper>
);
